import { S_TextNumberValue } from 'elements/minute/sidebar/sidebarComponents/atomic/TextNumberValue/TextNumberValue';
import { EFonts } from 'libs/styles/styling';
import { CSSProperties, useEffect, useRef, useState } from 'react';
import styled, { css } from 'styled-components/macro';

interface Props {
    value: string;
    placeholder?: string;
    width?: string;
    disabled?: boolean;
    autoFocus?: boolean;
    onChange?: (value: string) => void;
    onBlur?: (value: string) => void;
    className?: string;
    style?: CSSProperties;
    textAlign?: 'left' | 'center' | 'right';
}

export const TextValue = (props: Props): JSX.Element => {
    const [value, setValue] = useState<string>(props.value ?? '');
    const ref = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (props.value !== value) {
            setValue(props.value);
        }
    }, [props.value]);

    return (
        <S_TextValue
            ref={ref}
            style={props.style}
            className={props.className}
            type="text"
            disabled={props.disabled}
            value={value ?? ''}
            width={props.width}
            placeholder={props.placeholder}
            autoComplete="nope"
            autoFocus={props.autoFocus}
            $textAlign={props.textAlign}
            onChange={(e) => {
                setValue(e.target.value);
                props.onChange?.(e.target.value);
            }}
            onBlur={() => {
                props.onBlur?.(value);
            }}
            onKeyDown={(e) => {
                e.stopPropagation();
            }}
        />
    );
};

const S_TextValue = styled(S_TextNumberValue)<{ $textAlign: string; disabled: boolean }>`
    font-size: 12px;
    color: #141c54;
    font-family: ${EFonts.Regular};
    font-size: 12px;
    border-bottom: 1px solid #dadada;
    background: #f5f5f5;
    box-shadow: 0px 0px 20px 0px #dedede inset;
    height: 40px;
    text-align: ${(props) => props.$textAlign ?? 'center'};
    &:focus {
        background: #f5f5f5;
    }
    ${(props) =>
        props.disabled &&
        css`
            cursor: not-allowed;
        `}
`;
